<template>
    <div class="pages newTemplate">
        <div class="title mb-30">
            <p>
                <img src="../../assets/images/newIcon/add_tempted_icon.png" alt="">
                <span>新建模版</span>
            </p>
            <p>
            </p>
        </div>
        <div class="content">
            <div class="tabw" v-if="types==1">
                <el-form ref="form" :model="form" label-width="120px" >
                    <el-form-item label="模版类型：" :rules="{
                    required: true}">
                        <el-radio-group v-model="form.type">
                            <el-radio label="1">模版1（有优惠券）</el-radio>
                            <el-radio label="2">模版2（有优惠券）</el-radio>
                            <el-radio label="3">模版3（无优惠券）</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="业务系统：" :rules="{ required: true, message: '请选择业务系统', trigger: 'change' }">
                        <el-select v-model="form.region" placeholder="请选择业务渠道">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item>
                        <span slot="label">
                            banner：<span style="color:#999;">（xxx*xxx）</span>
                        </span>
                        <el-radio-group v-model="form.uploadType">
                            <el-radio label="1">默认</el-radio>
                            <el-radio label="2">上传图片（1张）</el-radio>
                        </el-radio-group>
                         <div class="uplods" v-if="form.uploadType==2">
                            <el-upload
                                class="avatar-uploader"
                                action="https://jsonplaceholder.typicode.com/posts/"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <p><i>*</i> 请按尺寸上传png/jpg格式且小于2M的图片</p>
                        </div>
                    </el-form-item>
                     <el-form-item>
                        <span slot="label">
                            背景图：<span style="color:#999;">（xxx*xxx）</span>
                        </span>
                        <el-radio-group v-model="form.uploadType">
                            <el-radio label="1">默认</el-radio>
                            <el-radio label="2">上传图片（1张）</el-radio>
                        </el-radio-group>
                        <div class="uplods" v-if="form.uploadType==2">
                            <el-upload
                                class="avatar-uploader"
                                action="https://jsonplaceholder.typicode.com/posts/"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <p><i>*</i> 请按尺寸上传png/jpg格式且小于2M的图片</p>
                        </div>
                    </el-form-item>
                    <el-form-item label="专题名称：" prop="name" :rules="{
                    required: true, message: '专题名称不能为空', trigger: 'blur'
                    }">
                        <el-input v-model="form.name" placeholder="专属特惠"></el-input>
                    </el-form-item>
                    <el-form-item label="按钮名称：" prop="name" :rules="{
                    required: true, message: '按钮名称：不能为空', trigger: 'blur'
                    }">
                        <el-input v-model="form.name" placeholder="立即领取"></el-input>
                    </el-form-item>
                    <el-form-item label="活动说明：" prop="desc" :rules="{
                    required: true, message: '渠道描述不能为空', trigger: 'blur'
                    }">
                        <el-input type="textarea" :rows="8" placeholder="" resize="none" v-model="form.desc"></el-input>
                    </el-form-item>
                    <el-form-item label="活动说明2：" prop="desc" :rules="{
                    required: true, message: '渠道描述不能为空', trigger: 'blur'
                    }">
                        <tinymce v-model="form.tinymce" :height="300" />
                    </el-form-item>
                   <el-form-item label="选择优惠券 ：" class="alinc">
                        <p class="addyh">
                            <el-button @click="showC"  type="text"    icon="el-icon-plus">添加优惠券</el-button>
                        </p>
                    </el-form-item>
                </el-form>
                <div class="f4 bf">
                    <div class="d1">
                        <p>共<span>{{total}}</span>条 已选中<span>0</span>条</p>
                        <p>
                            <el-button @click="batchDelete" plain class="kh-btn" icon="el-icon-delete"> 批量删除</el-button>
                        </p>
                    </div>
                    <el-table
                        :data="tableData3"
                        :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                        style="width: 100%;"
                        :cell-style="{textAlign: 'center',fontSize:'12px'}"
                        >
                        <el-table-column
                        type="selection"
                        width="55">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="优惠券名称"
                        show-overflow-tooltip
                        >
                        </el-table-column>

                        <el-table-column
                        prop="number"
                        label="类型"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="number"
                        label="渠道"
                        
                        cell-style="background:red;"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="xmember"
                        label="内容"
                    >
                        </el-table-column>
                        <el-table-column
                        prop="lmember"
                        label="状态"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="已领取"
                        width="240"
                        >
                            <template slot-scope="scope">
                                <div class="labelLi">
                                    <p>标签111</p>
                                    <p>标签222</p>
                                    <el-popover
                                    placement="bottom"
                                    width="200"
                                    trigger="click">
                                    <div class="labelAll">
                                        <el-tag>标签一</el-tag>
                                        <el-tag>标签一</el-tag>
                                    </div>
                                    <span class="s" slot="reference">...</span>
                                    </el-popover>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="剩余"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="已使用"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="操作"
                        width='200'
                        >
                            <template slot-scope="scope">
                                <el-button type="text" @click="ondelete">删除</el-button>
        
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page pageL">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 24px;"
                    :current-page="query.page_index"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.page_size"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total"
                    ></el-pagination>
                </div>
                <div class="scroll">
                
                <div class="template1" v-if="false">
                    <div class="titles">
                        <i class="el-icon-arrow-left"></i>
                        <span>活动名称</span>
                    </div>
                    <div class="bgt">
                        <p class="bner"><img src="../../assets/images/h5/moban_banner_h5.png" alt=""></p>
                        <p class="p2">
                            <img src="../../assets/images/h5/zs_bg.png" alt="">
                        </p>
                        <div style="positon:relative;">
                       
                        <div class="list">
                            <p class="p1"><img src="../../assets/images/h5/title_bg.png" alt=""></p>
                            <ul>
                                <li :style="`background:url(${imgList[0]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                        <span>满减券</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[2]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                        <span>折扣券</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[1]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                        <span>代金券</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[0]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                        <span>满减券</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[0]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                        <span>满减券</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[0]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                        <span>满减券</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                            </ul>
                            <p class="btns">
                                立即领取
                            </p>
                        </div>
                             
                        </div>
                        <div class="explain">
                            <p class="t">领取说明</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                        </div>
                    </div>
                </div>
                <div v-if="false" class="template1 template2">
                    <div class="titles">
                        <i class="el-icon-arrow-left"></i>
                        <span>活动名称</span>
                    </div>
                    <div class="bgt">
                        <p class="bner"><img src="../../assets/images/h5/mb_banner.png" alt=""></p>
                        <p class="p2">
                            <img src="../../assets/images/h5/ren_bg.png" alt="">
                        </p>
                        <div style="positon:relative;">
                       
                        <div class="list">
                            <p class="p1"><img src="../../assets/images/h5/title_bg2.png" alt=""></p>
                            <ul>
                                <li :style="`background:url(${imgList[3]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[4]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[5]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[3]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[3]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                                <li :style="`background:url(${imgList[3]}) no-repeat;background-size:100% 100%;`">
                                    <p>· 优惠券名称 ·</p>
                                    <p>
                                         <span><b>¥</b> 20</span>
                                    </p>
                                    <p>满499元可用</p>
                                </li>
                            </ul>
                            <p class="btns">
                                立即领取
                            </p>
                        </div>
                             
                        </div>
                        <div class="explain">
                            <p class="t">领取说明</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                            <p>1.领取的优惠券领取的优惠券领取的优惠券</p>
                        </div>
                    </div>
                </div> 
                <div class="template3">
                    <div class="titles">
                        <i class="el-icon-arrow-left"></i>
                        <span>活动名称</span>
                    </div>
                    <div class="contents" v-html="form.tinymce">
                    </div>
                    <p class="btns">
                        立即查看
                    </p>
                </div>   
                </div>
            </div>
            <span class="footer">
                <el-button class="quxiao" @click="handleClose" >取 消</el-button>
                <el-button type="primary"  @click="goType(2)">保 存</el-button>
            </span>
        </div>
        <customer-popup @doSelect='doSelect' ref="customerPopup"></customer-popup>

          <selectCoupon ref="selectCoupon"></selectCoupon>
    </div>
</template>

<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
const img1=require('../../assets/images/h5/manjianquan_bg.png');
const img2=require('../../assets/images/h5/daijinquan_bg.png');
const img3=require('../../assets/images/h5/zhekouquan_bg.png');
const img4=require('../../assets/images/h5/manjianquan_bg2.png');
const img5=require('../../assets/images/h5/zhekouquan_bg3.png');
const img6=require('../../assets/images/h5/daijinquan_bg1.png');
import selectCoupon from '../marketingCenter/components/selectCoupon'
import Tinymce from "@/components/Tinymce";
export default {
    data() {
        return {
            imgList:[img1,img2,img3,img4,img5,img6],
            query:JSON.parse(JSON.stringify(QUERY)),
            types:1,
            total:90,
             tableData3: [{
                name: '小程序',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '小红书',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"0",
                labellv:"30%"
                },{
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"0",
                labellv:"30%"
                }, {
                name: '抖音',
                number:"3000",
                xmember:"200",
                lmember:"0",
                labellv:"30%"
                },{
                name: '移动端',
                number:"3000",
                xmember:"200",
                lmember:"0",
                labellv:"30%"
            }],
            form: {
                tinymce:"",
                uploadType:'1',
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: "3",
                resource: '1',
                desc: '',
                imageUrl:""
            }
        }
    },
    components:{
        selectCoupon,
        Tinymce
    },
    methods: {
        //点击删除
        ondelete(){
                     this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton:true,
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })   
        },
        //点击批量删除
        batchDelete(){
             this.$confirm('此操作将批量删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton:true,
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        },
         showC(){
            this.$refs.selectCoupon.show()
        },
        doSelect(){

        },
         showPopup(type){
            this.$refs.customerPopup.show(type);
        },
        createds(val){
            console.log(val,111111)
            if(val.type==1){
                this.types=--this.types;
            }
        },
        goType(type){
            this.types=type;
            if(type==2){
                if(this.form.type==3){

                }
            }
        },
        handleClose(){
            this.$router.go(-1)
        },
    },
}
</script>
<style lang="less" scoped>
    .scroll{
          position: absolute;
        right: 76px;
        top: 180px;
        overflow-y:scroll;
        height:500px;
    }
    .template1{
        width: 375px;
      
        background: #EFEFEF;
        .titles{
            padding:10px 0;
            text-align: center;
            i{
                font-size:18px;
                float: left;
                margin-left: 10px;
                margin-top: 2px;
                font-weight: bold;
            }
            span{
                font-size: 18px;
                font-weight: 400;
                color: #333333;
            }
            
        }
        .bgt{
             padding-bottom:30px;
            height:100%;
            background: url('../../assets/images/h5/moban_bg.png') no-repeat;
            background-size: 100% 100%;
            .bner{
                img{
                    width:100%;
                    // height:100px;
                }
            }
            .p2{
                 margin-top:-45px;
                img{
                    width:100%;
                    // height:40px;
                   
                }
            }
            .list{
                position: relative;
                // position: absolute;
                // top:400px;
                border-radius: 10px;
                padding-bottom:15px;
                z-index: 10;
                margin:0 15px;
                margin-top:-30px;
                background:#fff;
                .p1{
                    text-align: center;
                    img{
                        // margin-top:-15px;
                        width:120px;
                    }
                }
                ul{
                    margin:0 15px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                }
               ul li{
                   margin-bottom:10px;
                   box-sizing: border-box;
                   padding:10px 15px;
                   width:48%;
                   background-size: 100% 100%;
                   p{
                       margin-bottom:2px;
                       &:first-of-type{
                           font-size: 12px;
                            font-weight: 400;
                            color: #FFFFFF;
                       }
                       &:nth-child(2){
                           display: flex;
                           justify-content: space-between;
                           align-items: center;
                           span{
                               font-size: 25px;
                                font-weight: bold;
                                color: #FFFFFF;
                                b{
                                    font-size:15px;
                                    color: #FFFFFF;
                                }
                                &:nth-child(2){
                                    // height:12px;
                                    padding:2px 5px;
                                    font-size:10px;
                                    font-weight: 400;
                                    border-radius: 17px;
                                    border: 1px solid #FFFFFF;
                                }
                               
                           }
                           
                       }
                        &:nth-child(3){
                            font-size: 12px;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                   }
               }
               .btns{
                   margin:0 30px;
                   text-align: center;
                   font-size: 18px;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 60px;
                   background:url('../../assets/images/h5/button_bg.png') no-repeat;
                   background-size:100% 100%;
               } 
            }
            .explain{
                margin:15px;
                margin-top:30px;
                padding-top:30px;
                border-top:1px dashed #fff;
                .t{
                    margin-bottom:10px;
                    font-size: 15px;
                    font-weight: 500;
                    color: #FFFFFF;
                }
                p{
                    font-size: 13px;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-bottom:10px;
                }
            }
        }
    }
    .template2{
        .bgt{
            background: url('../../assets/images/h5/moban_bg2.png') no-repeat;
            background-size: 100% 100%;
            .bner{
                padding-top: 62px;
                 text-align: center;
                 img{
                     width:80%;
                 }
                 
            }
            .p2{
                    margin-top: -84px;
            }
              .list{
                    background:#3905A4;
                    padding:15px 0;
                    ul li{
                        p{
                            text-align: center;
                             &:first-of-type{
                                font-size: 12px;
                                font-weight: 400;
                                color: #333 !important;
                            }
                            &:nth-child(2){
                                display: block;
                                // justify-content: space-between;
                                // align-items: center;
                                span{
                                    font-size: 25px;
                                    font-weight: bold;
                                    color: #333 !important;
                                    b{
                                        font-size:15px;
                                        color: #333 !important;
                                    }
                                    &:nth-child(2){
                                        // height:12px;
                                        padding:2px 5px;
                                        font-size:10px;
                                        font-weight: 400;
                                        border-radius: 17px;
                                        border: 1px solid #333 !important;
                                    }
                                    
                                }
                                
                            }
                            &:nth-child(3){
                                font-size: 12px;
                                font-weight: 400;
                                color: #333 !important;
                            }
                        }
                       
                    }
                    .btns{
                         background:url('../../assets/images/h5/button_bg2.png') no-repeat;
                   background-size:100% 100%;
                    }
                }
                
        }
    }
    .template3{
        width: 375px;
        .titles{
            padding:10px 0;
            text-align: center;
            background:#EFEFEF;
            i{
                font-size:18px;
                float: left;
                margin-left: 10px;
                margin-top: 2px;
                font-weight: bold;
            }
            span{
                font-size: 18px;
                font-weight: 400;
                color: #333333;
            }
            
        }
        .contents{
            padding:15px;
        }
        .btns{
            text-align: center;
            background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
            box-shadow: 0px 6px 8px 0px rgba(144, 224, 255, 0.53);
            border-radius: 48px;
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 50px;
            letter-spacing: 14px;
            margin:30px 50px;
        }
    }
    .title{
        display: flex;
        justify-content: space-between;
        
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    /deep/ .el-form-item__label{
        line-height: 18px;
    }
    
    .content{
        // padding:30px;
        .checkTab{
            background: #fff;
            padding:60px 0;
            display: flex;
            justify-content: center;
            border-radius: 6px;
            li{
                display: flex;
                align-items: center;
                margin-right:220px;
                position: relative;
                &:last-child{
                    margin:0;
                    &::after{
                        left: -206px;
                    }
                }
                &:first-child{
                    
                    &::after{
                        display:none;
                    }
                    
                }
                &:nth-child(2){
                    &::after{
                        left: -205px;
                    }
                    
                }
                
                &::after{
                    content: '';
                    position: absolute;
                    top: 30px;
                    border-bottom: 1px dashed #A7A7A7;
                    width: 190px;
                    height: 2px;
                }
            }
            .active{
                &::after{
                    border-bottom: 1px dashed #327EFF;
                }
                p{
                    &:last-child{
                        color: #327EFF;
                    }
                    &:first-child{
                        background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
                        color:#fff;
                    }
                    span{
                        &:first-child{
                            color:#327EFF;
                        }
                        &:last-child{
                            color:#484848;
                        }
                    }
                }
            }
            p{
                // text-align: center;
                &:first-child{
                    margin:0 auto;
                    margin-right:20px;
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    line-height: 64px;
                    text-align: center;
                    background: #EBEBEB;
                    font-size: 34px;
                    font-weight: 500;
                    color: #fff;
                }
                &:last-child{
                    font-size: 14px;
                    font-weight: 400;
                    color: #A1A1A1;
                    span{
                        display: block;
                        color: #999990;
                        &:first-child{
                            margin-bottom:10px;
                            font-size: 20px;
                            font-weight: 500;
                            
                        }
                    }
                }
            }
        }
        .tabw{
            // width:60%;
            padding:30px;
            border-radius: 6px;
            background: #fff;
            .el-form{
                width:60%;
            }
            .el-select{
                width:100%;
            }
            /deep/.el-textarea .el-textarea__inner{
                // width:100%;
                border:0;
                background:#F6F6F6;
            }
            /deep/.el-input .el-input__inner{
                border-radius: 30px;
                background: #F6F6F6;
                border: 0px;
            }
            .min_ipt{
                margin:0 10px;
                width:100px;
            }
            .liex{
                margin-top:15px;
                font-size: 10px;
                font-weight: 400;
                color: #999;
                i{
                    color: #E02020;
                }
            }
            .el-form-item{
                margin-bottom:30px;
            }
            .uplods{
                margin-top:15px;
                p{
                    i{
                        color:#E02020;
                    }
                    margin-top:10px;
                    font-size: 10px;
                    font-weight: 400;
                    color: #999;
                }
            }
            .alinc{
                display: flex;
                align-items: center;
                /deep/ .el-form-item__content{
                    margin-left:0 !important;
                }
            }
         
            /deep/.addyh .el-button{
                // padding:0;
            }
        }
        .f4{
            border-radius: 8px;
            .d1{
                border:1px solid #DADADA;
                border-bottom:0px;
                border-radius: 10px 10px 0 0;
                padding:15px;
                p{
                    &:first-child{
                        font-size: 16px;
                        font-weight: 500;
                        color: #333940;
                        span{
                            color:#327EFF;
                        }
                    }
                    
                }
                display: flex;
                justify-content: space-between;
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
                .kh-btn.el-button{
                    border-radius: 15px;
                    border: 1px solid #327EFF;
                    color:#327EFF;
                }
            }
            /deep/ .el-checkbox__inner{
                border-radius: 15px;
            }
            .labelLi{
                display: flex;
                align-items: center;
                justify-content: center;
                p{
                    margin-right:8px;
                    display: inline-block;
                    width:40px;
                    padding:0px 8px;
                    background: rgba(211, 236, 255, 0.4);
                    border-radius: 15px;
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    font-size: 12px;
                    font-weight: 400;
                    color: #0091FF;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    // &:last-child{
                    //     padding:0 4px;
                    //     text-align: center;
                    //     // border:0;
                    //     // background:#fff;
                    // }
                    
                }
                .s{
                    background: rgba(211, 236, 255, 0.4);
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    padding: 2px 10px;
                    color: #0091FF;
                    border-radius: 18px;
                    width: auto;
                }
            }
           
        }
         .page{
                padding-bottom:60px;
            }
        /deep/ .el-tag{
            border-radius: 30px;
            margin-right:10px;
            margin-bottom:10px;
        }
        .imgs{
            width:16px;
            vertical-align: middle;
            margin-left:10px;
        }
        .footer{
            display: block;
            background: #fff;
            padding:15px 30px;
            border-top:1px solid #ededed;
            .el-button{
                border-radius: 30px;
            }
        }
    }
   
</style>